/* eslint-disable react-hooks/exhaustive-deps */
// eslint-disable-next-line import/no-cycle
import { useDebounce } from 'hooks';
import { useState, useLayoutEffect } from 'react';

interface Size {
  width: number | undefined;
  height: number | undefined;
}

interface IUseWindowSize {
  breakpoints: Breakpoint;
  windowSize: Size;
}
interface Breakpoint {
  isSm: boolean | undefined;
  isMd: boolean | undefined;
  isLg: boolean | undefined;
  isXl: boolean | undefined;
}

function mountBreakpoint(breakpoint: Breakpoint, size: string): Breakpoint {
  const keys = Object.keys(breakpoint);
  const mountedBreakpoint = keys.reduce((previous, current) => {
    if (current === size) {
      return {
        ...previous,
        [current]: true,
      };
    }
    return {
      ...previous,
      [current]: false,
    };
  }, {} as Breakpoint);

  return mountedBreakpoint;
}
const Breakpoints = {
  isSm: 'isSm',
  isMd: 'isMd',
  isLg: 'isLg',
  isXl: 'isXl',
};
export default function useWindowSize(): IUseWindowSize {
  const [windowSize, setWindowSize] = useState<Size>({
    width: undefined,
    height: undefined,
  });
  const [breakpoints, setBreakpoints] = useState<Breakpoint>({
    isSm: undefined,
    isMd: undefined,
    isLg: undefined,
    isXl: undefined,
  });

  function getBreakPoint(width: number) {
    if (width > 0 && width <= 410) {
      setBreakpoints(breakpoint =>
        mountBreakpoint(breakpoint, Breakpoints.isSm),
      );
    } else if (width > 410 && width <= 1110) {
      setBreakpoints(breakpoint =>
        mountBreakpoint(breakpoint, Breakpoints.isMd),
      );
    } else if (width >= 1920) {
      setBreakpoints(breakpoint =>
        mountBreakpoint(breakpoint, Breakpoints.isXl),
      );
    } else {
      setBreakpoints(breakpoint =>
        mountBreakpoint(breakpoint, Breakpoints.isLg),
      );
    }
  }

  function handleResize() {
    setWindowSize({
      width: window.innerWidth,
      height: window.innerHeight,
    });
    getBreakPoint(window.innerWidth);
  }
  const windowsSizeDebounce = useDebounce(handleResize, 500);

  useLayoutEffect(() => {
    windowsSizeDebounce();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return { windowSize, breakpoints };
}
